import React, { use, useEffect, useState } from "react";
import { Box, Typography, LinearProgress, Button, useMediaQuery } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import {FindPets} from "../services/AIPetFinder";
import { getListofFoundPets, getListofLostPets} from "../services/api";

export default function PetSearchPage() {
    const isMobile = useMediaQuery("(max-width:900px)");
    const [progress, setProgress] = useState(2);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const imageFiles = location.state?.imageFiles;
    const animal = location.state?.animal;
    const [showLoading, setShowLoading] = useState(true);
    const [searchParams] = useSearchParams();
    const petlost = searchParams.get("petlost");
    

    useEffect(() => {
        let timer;
        let isMounted = true;

        const fetchMatches = async () => {
            try {
                const response = petlost === "true" ? await getListofFoundPets() : await getListofLostPets();
                const petsData = response.data.pets || [];
                const result = await FindPets(petsData, imageFiles, animal); 
                if (result.length != 0) {
                    isMounted = false;
                    const navigatetoPage = petlost === "true" ? "/pet_search_result?petlost=true" : "/pet_search_result";
                    navigate(navigatetoPage, { state: { possibleMatches: result } });
                }
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    console.log("No pets found for this user.");
                }
                console.error("Error loading pets:", err);
            }
        };

        fetchMatches();

        if (showLoading) {
            timer = setInterval(() => {
                setProgress((oldProgress) => {
                    if (oldProgress >= 100) {
                        clearInterval(timer);
                        setShowLoading(false);
                        return 100;
                    }
                    return Math.min(oldProgress + Math.random() * 1, 100);
                });
            }, 100);
        }

        return () => {
            isMounted = false;
            if (timer) clearInterval(timer);
        };
    }, [showLoading]);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                background: "#FFF9F0",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Navbar />
            {/* Loading Screen */}
            {showLoading && (
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        px: isMobile ? 2 : 0,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: isMobile ? 32 : 48,
                            color: "#FFB60C",
                            mb: 1,
                            mt: isMobile ? 4 : 0,
                            textAlign: "center",
                        }}
                    >
                        {progress < 100 ? `${Math.floor(progress)}%` : "100%"}
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 500,
                            fontSize: isMobile ? 16 : 20,
                            color: "#222",
                            mb: 3,
                            textAlign: "center",
                        }}
                    >
                        {progress < 100
                            ? t('Matchingwithdb') || "Matching with database records..."
                            : t('Matching complete!')}
                    </Typography>
                    <Box sx={{ width: isMobile ? "90%" : 400, mb: 1 }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                height: 8,
                                borderRadius: 4,
                                background: "#FFF0CD",
                                "& .MuiLinearProgress-bar": {
                                    background: "#FFB60C",
                                },
                            }}
                        />
                    </Box>
                    <Typography
                        sx={{
                            fontSize: 14,
                            color: "#B0B0B0",
                            mt: 1,
                            textAlign: "center",
                        }}
                    >
                        {t('Searching') || "Searching"}
                    </Typography>
                </Box>
            )}

            {/* No Result Screen */}
            {!showLoading && (
                <>
                    <Box sx={{ color: "black", minWidth: 0, ml: isMobile ? 5 : 10, display: 'flex', mt: 15 }}>
                        <Button
                            sx={{ color: "black", minWidth: 0, cursor: 'pointer' }}
                            onClick={() => navigate("/")}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 24" fill="none">
                                <path d="M12 22L2 12L12 2" stroke="#050505" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Button>
                        <Typography sx={{ ml: 1, fontSize: isMobile ? 26 : 34, fontWeight: 700 }}>{t('SearchResults')}</Typography>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            px: isMobile ? 2 : 0,
                        }}
                    >
                        <Box sx={{ width: "100%", maxWidth: 900, mx: "auto", mt: isMobile ? 2 : 6 }}>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",

                                }}
                            >
                                <Box
                                    sx={{
                                        width: isMobile ? 60 : 90,
                                        height: isMobile ? 60 : 90,
                                        borderRadius: "50%",
                                        background: "#FFF9F0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 3,
                                    }}
                                >

                                    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M83.9938 84.0016L67.4062 67.4141" stroke="#D1D1D1" stroke-width="7.62644" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M43.4062 75.8906C61.0794 75.8906 75.4062 61.5637 75.4062 43.8906C75.4062 26.2175 61.0794 11.8906 43.4062 11.8906C25.7331 11.8906 11.4062 26.2175 11.4062 43.8906C11.4062 61.5637 25.7331 75.8906 43.4062 75.8906Z" stroke="#D1D1D1" stroke-width="6.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M52.9969 34.2891L33.7969 53.4891" stroke="#D1D1D1" stroke-width="6.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M33.7969 34.2891L52.9969 53.4891" stroke="#D1D1D1" stroke-width="6.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </Box>
                                <Typography
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: isMobile ? 14 : 18,
                                        color: "#222",
                                        mb: 3,
                                        textAlign: "center",
                                        maxWidth: 500,
                                    }}
                                >
                                    {petlost ? t('NoMatchLostMsg') : t('NoMatchFoundMsg')}
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 2, width: isMobile ? "100%" : "auto" }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            background: "#FFB60C",
                                            color: "#000",
                                            fontWeight: 700,
                                            px: 4,
                                            py: 1.5,
                                            borderRadius: 1,
                                            fontSize: 16,
                                            width: isMobile ? "100%" : "250px",
                                            mb: isMobile ? 1 : 0,
                                            "&:hover": { background: "#FFB60C" }
                                        }}
                                        onClick={() => navigate("/all_lost_pets")}
                                    >
                                        {t('ViewallLostPets')}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            borderColor: "#FFB60C",
                                            color: "#FFB60C",
                                            fontWeight: 700,
                                            px: 4,
                                            py: 1.5,
                                            borderRadius: 1,
                                            fontSize: 16,
                                            width: isMobile ? "100%" : "250px",
                                            "&:hover": { borderColor: "#FFB60C", background: "#FFF9F0" }
                                        }}
                                        onClick={() => {petlost ? navigate("/pet_lost_member") :  navigate("/pet_found_report")}}
                                    >
                                        {t('Report')}
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                </>
            )}
            <Footer />
        </Box>
    );
}